import { render } from "./DropOffArea.vue?vue&type=template&id=20f9d105&scoped=true"
import script from "./DropOffArea.vue?vue&type=script&setup=true&lang=js"
export * from "./DropOffArea.vue?vue&type=script&setup=true&lang=js"

import "./DropOffArea.vue?vue&type=style&index=0&id=20f9d105&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f9d105"],['__file',"src/components/elements/DropOffArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20f9d105"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20f9d105', __exports__)) {
    api.reload('20f9d105', __exports__)
  }
  
  module.hot.accept("./DropOffArea.vue?vue&type=template&id=20f9d105&scoped=true", () => {
    api.rerender('20f9d105', render)
  })

}


export default __exports__